/*--------------------------------------------------------------------------*
 * ハンバーガーメニュー
 *--------------------------------------------------------------------------*/
$(function(){
    $('[data-nav-trigger]').on('click', function(){
        $('[data-nav-trigger]').toggleClass('active');
        $('[data-nav]').toggleClass('visible');
        $('[data-navbg]').fadeToggle(500);
        ($('html').css('overflow') === 'hidden')? $('html').css('overflow', 'auto') : $('html').css('overflow', 'hidden');
    });

    $('[data-nav] a').on('click', function(){
        $('[data-nav-trigger]').toggleClass('active');
        $('[data-nav]').toggleClass('visible');
        $('[data-navbg]').fadeToggle(500);
        ($('html').css('overflow') === 'hidden')? $('html').css('overflow', 'auto') : $('html').css('overflow', 'hidden');
    });
});
